// extracted by mini-css-extract-plugin
module.exports = {"featuredCategoryImgWrapper":"FeatureCategories_featuredCategoryImgWrapper__oEp5d","featuredCategories":"FeatureCategories_featuredCategories__j5Dj9"};